import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BankIdVerificationResponse, BypassCategory } from '@app/sales/models/sps-order-item.model';
import { AppData } from '@app/shared/models/appdata.model';
import { BankIdStatusRequest } from '@app/shared/models/bank-id-status-request.model';
import { BankIdStatusResponse } from '@app/shared/models/bank-id-status-response.model';

@Injectable({
  providedIn: 'root',
})
export class VerificationService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v1';

  initiateVerification(msisdn?: string, email?: string) {
    const apiUrl = `${this.apiUrl}/bankid/initiate`;
    return this.http.post<BankIdVerificationResponse>(apiUrl, { msisdn, email });
  }

  reinitiateVerification(orderServiceId: string, msisdn?: string, email?: string) {
    const apiUrl = `${this.apiUrl}/bankid/reinitiate`;
    return this.http.post<BankIdVerificationResponse>(apiUrl, { msisdn, orderServiceId, email });
  }

  getVerificationStatus(bankIdStatusRequest: BankIdStatusRequest) {
    const apiUrl = `${this.apiUrl}/bankid/status`;
    return this.http.post<BankIdStatusResponse>(apiUrl, bankIdStatusRequest, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  bypassBankIdVerification(orderServiceId: string, notes: string, userId: string) {
    const apiUrl = `${this.apiUrl}/bankid/${orderServiceId}/bypass`;
    const bypassCategory = BypassCategory.BankId;
    const bypassInfoRequest = {
      notes,
      bypassedByUserId: userId,
      bypassCategory,
    };
    return this.http.patch(apiUrl, bypassInfoRequest);
  }

  createAuthenticatedVerification(verificationCode: string) {
    const apiUrl = `${this.apiUrl}/bankid/create-authenticated-verification`;
    return this.http.post<BankIdVerificationResponse>(apiUrl, { verificationCode });
  }
}
